import { css, FlattenSimpleInterpolation } from 'styled-components';

import { ThemedProperties } from '@r1-frontend/ui-kit/themes/types';

type TProps = {
    $small?: boolean,
    $withAnimation?: boolean,
}

const getAnimation = () => ({ theme: { breakpoints }, $small = false, $withAnimation = true }: ThemedProperties<TProps>): FlattenSimpleInterpolation => {
    if (!$withAnimation) {
        return [];
    }

    const transition = 'transition: transform .2s;';

    if ($small) {
        return css`
            ${transition}
            
            &:active {
                transform: scale(0.89);
            }
        `;
    }

    return css`
        ${transition}

        &:active {
            transform: scale(0.9);

            @media (min-width: ${breakpoints.tablet}) {
                transform: scale(0.83);
            }
        }
    `;
};

export default getAnimation;
